import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=43ef1a3c&scoped=true"
var script = {}
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=43ef1a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ef1a3c",
  null
  
)

export default component.exports